import { Icon, IconButton, Paper } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IFilteringViewModel } from "../../../_common/interface/table";
import { PageHeader } from "../../../_components/header/page.header";
import { CommonTable } from "../../../_components/table/common.table";
import { formFieldKeyService } from "../../../_services/formFieldKey.service";
import { FormFieldValueTypeEnum } from "../../../_common/enum/forms/formFieldValueType.enum";

export function FormFieldKeyList(params: { count: number, editorRef: React.MutableRefObject<any> }) {

    const [data, setData] = useState({ items: [], count: 0 });
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState<IFilteringViewModel>({ search: '', limit: 100, page: 0, order: 'desc', orderBy: '' });
    let navigate = useNavigate();

    const { formTemplateSectionId } = useParams<{ formTemplateSectionId: string }>();

    useEffect(() => {
        fetchData();
    }, [filter, params.count]);

    function fetchData() {
        setLoading(true);
        return formFieldKeyService
            .getAll(+(formTemplateSectionId || 0))
            .then(
                (json) => {
                    setData(json)
                }
            )
            .finally(() => setLoading(false));
    }

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                accessorKey: 'sectionOrder',
                header: 'Order',
            },
            {
                accessorKey: 'label',
                header: 'Label',
            },
            {
                accessorKey: 'formFieldValueTypeId',
                header: 'Type',
                accessorFn: (rowData: any) => <>{FormFieldValueTypeEnum[rowData.formFieldValueTypeId]}</>
            },
            {
                accessorKey: 'subSectionName',
                header: 'Section Name',
            },
            {
                accessorKey: 'subValues',
                header: 'Sub Values',
            },
            {
                accessorKey: 'id',
                header: '',
                accessorFn: (rowData: any) => <>{rowData.formFieldKeyLookupList && rowData.formFieldKeyLookupList.length ? rowData.formFieldKeyLookupList.map((m: any) => (m.label||m.lookupValue)).join(", ").toString() : ""}</>
            },

        ],
        [],
    );
    return (
        <>
            <PageHeader
                pageName="Form Field Keys"
                buttonName="Form Field Keys"
                onClick={() => navigate(`CreateFormFieldKey`)}
                actionType="create"
            />

            <Paper>
                <CommonTable
                    columns={columns}
                    data={data}
                    onEdit={(id) => { navigate(`EditFormFieldKey/${id}`) }}
                    filter={filter}
                    setFilter={(_filter) => { setFilter({ ...filter, ..._filter }) }}
                    // onDelete={onDelete}
                    isLoading={isLoading}
                />

            </Paper>
        </>
    );
}